<sb-card halfHeight="true">
  <div card-header>
    <h1>Bid / Impression Rate</h1>
    <small>Past 7 Days</small>
  </div>
  <sb-chart chartType="lineChart" card-body [chartData]="bidImpressionRate"></sb-chart>
</sb-card>
